import React, { Component } from 'react';
import Icon from '@ant-design/icons';
import Style from './style';

const SearchSvg = () => (
    <svg width="1em" height="1em" fill="none" aria-hidden="true">
        <path d="M9.5 15.5C13.366 15.5 16.5 12.366 16.5 8.5C16.5 4.63401 13.366 1.5 9.5 1.5C5.63401 1.5 2.5 4.63401 2.5 8.5C2.5 12.366 5.63401 15.5 9.5 15.5Z" stroke="currentColor"/>
        <path d="M15.143 13.1431L17.143 15.1431" stroke="currentColor" strokeLinecap="round"/>
    </svg>
)

class SearchIcon extends Component {
    constructor (props) {
        super(props);
    }

    render () {
        return (
            <Icon className={`cicon ${this.props.className||''}`} style={Object.assign({},Style,this.props.style)} component={SearchSvg} aria-hidden="true" />
        )
    }
}
export default SearchIcon;
